import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ResourceLoading } from "../../../../components/utils/ResourceLoading";
import { ResourceError } from "../../../../components/utils/ResourceError";
import { ResourceEmpty } from "../../../../components/utils/ResourceEmpty";
import DashboardHeader from "../../../../components/dashboard/dashboardHeader";
import { mapErrors } from "../../../../components/Utils";
import { fetchUser } from "../../../../api/users";
import { UserInfo } from "../../../../components/dashboard/company/users/user-info";
import { UserEmployment } from "../../../../components/dashboard/company/users/user-employment";
import { UserRoles } from "../../../../components/dashboard/company/users/user-roles";

export const User = (props) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const dispatch = useDispatch();

  const [itemState, setItemState] = useState({
    isLoading: true,
    error: false,
    errors: [],
    user: {},
  });

  // Deconstruct itemState (Store)
  const { isLoading, error, errors, user } = itemState;

  const item = user;

  const getUser = async () => {
    const params = {
      fields:
        "id,displayTitle,name,email,mobile,mobile_work,image_url,roles,approved,working_posistion,active,show_in_dropdown,show_on_website,department,employment.*,user_children.*,user_next_of_kins.*",
    };
    return fetchUser(id, params)
      .then((res) => {
        if (res.data.id) {
          setItemState((prevState) => ({
            ...prevState,
            isLoading: false,
            user: { ...res.data, is_editable: res.data.is_editable !== false }, // Default to true if not set
          }));
        }
      })
      .catch((err) => {
        let errors = null;
        if (err?.data?.errors) {
          errors = mapErrors(err.data.errors);
        } else {
          errors = ["Something went wrong"];
        }
        console.error("Error fetching user:", errors); // Debug log
        setItemState((prevState) => ({
          ...prevState,
          isLoading: false,
          user: {},
          error: true,
          errors: errors,
        }));
      });
  };

  useEffect(() => {}, [itemState]);

  const onRefresh = (data) => {
    setItemState((prevState) => ({
      ...prevState,
      isLoading: false,
      user: data,
    }));
  };

  const [selectedTab, setSelectedTab] = useState(0);

  useEffect(() => {
    getUser();
  }, [dispatch, selectedTab]);

  const tabs = [
    { name: "Detaljer", href: "#", component: <UserInfo item={item} /> },
    {
      name: "Employment",
      href: "#",
      component: (
        <UserEmployment userItem={item} onRefresh={(data) => onRefresh(data)} />
      ),
    },
    {
      name: "Roles",
      href: "#",
      component: (
        <UserRoles item={item} onRefresh={(data) => onRefresh(data)} />
      ),
    },
  ];

  const headerActions = [
    // {
    //   component: null,
    //   label: "Ge Robin en Øl",
    //   description: "",
    //   path: null,
    //   action: () => toast.success("Hej Robin"),
    //   icon: ArrowPathRoundedSquareIcon,
    //   textColor: "text-teal-700",
    //   bgColor: "bg-white",
    //   hidden: false,
    //   menu: true,
    // },
  ];

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  function userTabs() {
    return (
      <div>
        <div className="sm:hidden">
          <label htmlFor="tabs" className="sr-only">
            Select a tab
          </label>
          {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
          <select
            onChange={(e) => setSelectedTab(e.target.value)}
            id="tabs"
            name="tabs"
            className="block w-full rounded-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500"
            defaultValue={tabs[selectedTab].name}
          >
            {tabs.map((tab, tabIdx) => (
              <option key={tab.name} value={tabIdx}>
                {tab.name}
              </option>
            ))}
          </select>
        </div>
        <div className="hidden sm:block">
          <nav
            className="isolate flex divide-x divide-gray-200 rounded-lg shadow"
            aria-label="Tabs"
          >
            {tabs.map((tab, tabIdx) => (
              <a
                key={tab.name}
                onClick={() => setSelectedTab(tabIdx)}
                className={classNames(
                  tabIdx === selectedTab
                    ? "text-gray-900"
                    : "text-gray-500 hover:text-gray-700",
                  tabIdx === 0 ? "rounded-l-lg" : "",
                  tabIdx === tabs.length - 1 ? "rounded-r-lg" : "",
                  "cursor-pointer group relative min-w-0 flex-1 overflow-hidden bg-white py-4 px-4 text-center text-sm font-medium hover:bg-gray-50 focus:z-10"
                )}
                aria-current={tabIdx === selectedTab ? "page" : undefined}
              >
                <span>{tab.name}</span>
                <span
                  aria-hidden="true"
                  className={classNames(
                    tabIdx === selectedTab ? "bg-indigo-500" : "bg-transparent",
                    "absolute inset-x-0 bottom-0 h-0.5"
                  )}
                />
              </a>
            ))}
          </nav>
        </div>
      </div>
    );
  }

  const renderContent = () => {
    if (isLoading) {
      return (
        <div className="">
          <ResourceLoading />
        </div>
      );
    }
    if (error && errors) {
      return <ResourceError errors={errors} />;
    }

    if (!item?.id) {
      return <ResourceEmpty />;
    }

    return (
      <>
        <DashboardHeader
          subtitle=""
          actions={headerActions}
          title={user?.displayTitle}
          meta={
            [
              // { label: "test", icon: Cog6ToothIcon }
            ]
          }
          //   mainButton={{
          //     label: "New",
          //     action: () => setCaseDialogOpen(true),
          //     path: null,
          //     color: "",
          //     icon: PlusIcon,
          //   }}
        >
          <div className="mx-auto mt-8 grid max-w-3xl grid-cols-1 gap-6 overflow-visible sm:px-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-3">
            <div className="space-y-6 overflow-visible lg:col-span-3 lg:col-start-1 sm:col-span-3">
              {userTabs()}
              {tabs[selectedTab].component}
            </div>
          </div>
        </DashboardHeader>
      </>
    );
  };

  return <>{renderContent()}</>;
};
